import { buildSearchListingsPagePath } from "../../../hooks/useSearch/utils/buildSearchPath";
export var transformGoogleSearchSuggestions = function transformGoogleSearchSuggestions(_ref) {
  var results = _ref.results;
  var suggestions = results.searchTerms.suggestions;
  return {
    groups: [{
      suggestions: suggestions.map(function (_ref2, index) {
        var suggestion = _ref2.suggestion;
        return {
          globalIndex: index,
          name: suggestion,
          href: buildSearchListingsPagePath(suggestion, index + 1),
          type: 'term'
        };
      })
    }],
    suggestionsCount: suggestions.length
  };
};